import Vue from 'vue'
import VueRouter from 'vue-router'
import RenseignementProfessionnel from '../components/RenseignementProfessionnel.vue'
import Facture from '../views/Facture.vue'
import NotFound from '../views/Errors/NotFound.vue'
import Internal from '../views/Errors/Internal.vue'
import TableauDesMembres from '../views/TableauMembres.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/RenseignementProfessionnel/user/:contactId/type/:type/redirect/:redirect',
        name: 'RenseignementProfessionnel',
        component: RenseignementProfessionnel
    },
    {
        path: '/facture/:idFacture',
        name: '/facture',
        component: Facture,
        meta: {
            title: 'Facture | OEAQ'
        }
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: 'Ressource absente | OEAQ'
        }
    },
    {
        path: '/500',
        name: 'InternalError',
        component: Internal,
        meta: {
            title: 'Erreur interne | OEAQ'
        }
    },
    { 
        path: '/tableauDesMembres',
        name: 'TableauDesMembres',
        component: TableauDesMembres,
        meta: {
            title: 'Tableau des membres | OEAQ'
        }
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})
import { loadLanguageAsync } from '../plugins/i18n'

router.beforeEach((to, from, next) => {
    loadLanguageAsync().then(() => { next() })
})

export default router
